import { Box, Flex, Heading } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { Markdown } from '~/components/markdown';
import { SanityImage } from '~/components/sanity-image';
import { SanityImageType } from '~/features/page-template/models/image';

export type CompanyAboutSectionProps = {
  about: string;
  name: string;
  logo?: SanityImageType | null;
  theme?: 'light' | 'dark';
};

export function CompanyAboutSection({ about, name, logo, theme = 'dark' }: CompanyAboutSectionProps) {
  return (
    <Box
      as='section'
      bgGradient='linear(135deg, blue.500, purple.500)'
      padding={{
        base: '40px 0px',
        md: '80px 0px',
      }}
    >
      <ContentContainer>
        <Flex
          gap='40px'
          alignItems={{
            base: 'flex-start',
            md: 'center',
          }}
          flexDir={{
            base: 'column',
            md: 'row',
          }}
        >
          {logo && (
            <Box
              backgroundColor={theme === 'dark' ? 'blue.800' : 'white'}
              borderRadius='24px 4px 4px 4px'
              boxShadow='lg'
              flexGrow='0'
              flexShrink='0'
              padding='44px 34px'
            >
              <SanityImage
                alt=''
                image={logo}
                sizes='298px'
                style={{
                  pointerEvents: 'none',
                  objectFit: 'contain',
                }}
              />
            </Box>
          )}
          <Box color='white' flex='1'>
            <Heading as='h2' marginBottom='16px' size='h1'>
              About {name}
            </Heading>
            <Markdown markdownText={about} />
          </Box>
        </Flex>
      </ContentContainer>
    </Box>
  );
}
